// For some pages like LogIn, we don't want logged in users accessing them
// The same can be said for a lot of the auth related stuff
import React, { useEffect } from "react";

import { useHistory, useLocation, Route } from "react-router-dom";

import { useAuthContext } from "@/components/AuthProvider";
import Loading from "@/components/Loading";
import { CMP_SHOP_URL, DASHBOARD_HOME_URL } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import { needsOtpAction } from "@/hooks/useOtpApi";

// TODO: review all the pages and see if this should be used like it is for SignIn page
function LoggedOutRoute({ partners, ...props }) {
  const history = useHistory();
  const { user, otp } = useAuthContext();
  const location = useLocation();

  const { resolvedUrls } = useCmpRelatedUrl();

  // Redirect to login page if the user is loaded but is in fact null
  useEffect(() => {
    if (user && !needsOtpAction(otp)) {
      // Honour an explicit `next` destination (e.g. a marketing deep link that
      // sent the user here to log in), so they land where they intended.
      const next = new URLSearchParams(location.search).get("next");
      if (next) {
        history.push(next);
        return;
      }
      if (user.practitionerProfile?.id && user.practitionerProfile?.approved) {
        history.push(resolvedUrls[CMP_SHOP_URL]);
      } else {
        if (partners) {
          // if intended for partners dashboard, but they aren't approved
          // hard redirect to home, force a refresh and let them redirect
          window.location.href = DASHBOARD_HOME_URL;
        } else {
          history.push(DASHBOARD_HOME_URL);
        }
      }
    }
    // eslint-disable-next-line
  }, [user, otp, resolvedUrls[CMP_SHOP_URL], location.search]);

  // If we are waiting for the redirect to kick in, render a loading
  // component instead of the actual route
  if (user && !needsOtpAction(otp)) {
    return <Loading />;
  }

  return <Route {...props} />;
}

export default LoggedOutRoute;
